/* Csilla — card sale badges (outono 2026)
   Injeta badge -X% KEDVEZMÉNY vermelho em todas as cards de produto com compare_at,
   e esconde os badges nativos do tema (inconsistentes). */
(function () {
  function toNum(txt) {
    if (!txt) return NaN;
    var digits = txt.replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.');
    return parseFloat(digits) || NaN;
  }
  function apply() {
    var cards = document.querySelectorAll('.product-item');
    cards.forEach(function (card) {
      if (card.querySelector('.cs-card-badge')) return;
      var boxes = card.querySelectorAll('.badge-box');
      boxes.forEach(function (b) { b.style.display = 'none'; });
      var reg = card.querySelector('.price-item--regular, .price--compare, .price-item--compare, .old-price');
      var sale = card.querySelector('.price-item--sale, .price--current, .new-price');
      if (!reg || !sale) return;
      var a = toNum(reg.textContent);
      var b = toNum(sale.textContent);
      if (!(a > 0) || !(b > 0) || b >= a) return;
      var pct = Math.round((1 - b / a) * 100);
      if (pct < 5) return;
      var img = card.querySelector('.product-item__image, .product-item__bg, .card__media');
      if (!img) return;
      var badge = document.createElement('span');
      badge.className = 'cs-card-badge';
      badge.textContent = '-' + pct + '% KEDVEZMÉNY';
      img.appendChild(badge);
    });
  }
  var css = document.createElement('style');
  css.textContent =
    '.cs-card-badge{position:absolute;top:10px;left:10px;z-index:6;background:#E13C3C;color:#fff;' +
    'font-weight:800;font-size:12px;line-height:1;padding:6px 10px;border-radius:4px;' +
    'letter-spacing:.2px;box-shadow:0 2px 6px rgba(0,0,0,.18)}' +
    '.product-item__image{position:relative}.product-item__bg{position:relative}' +
    '@media(max-width:480px){.cs-card-badge{font-size:11px;padding:5px 8px;top:8px;left:8px}}';
  document.head.appendChild(css);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  // re-aplicar após navegações/lazy (collection filters e quick view)
  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(apply, 300);
  }).observe(document.body, { childList: true, subtree: true });
})();